import { IListBoxItem, ListBoxItemType } from "azure-devops-ui/ListBox";

export const dropdownItems: Array<IListBoxItem<{}>> = [
    { id: "header", text: "Header", type: ListBoxItemType.Header },
    { id: "first", text: "first" },
    { id: "divider", type: ListBoxItemType.Divider },
    { id: "header2", text: "Header 2", type: ListBoxItemType.Header },
    { id: "second", text: "second" },
    { id: "third", text: "third" },
    { id: "fourth", text: "fourth" },
    { id: "sixth", text: "sixth" },
    { id: "seventh", text: "seventh" },
    { id: "eighth", text: "eighth" },
    { id: "ninth", text: "ninth" },
    { id: "tenth", text: "tenth" },
    { id: "eleventh", text: "eleventh" },
    { id: "twelvth", text: "twelvth" },
    { id: "thirteenth", text: "thirteenth" },
    { id: "fourteenth", text: "fourteenth" },
    { id: "fifteenth", text: "fifteenth" }
];
